class ProductColours extends window.BAO.CustomElement() {
  setupListeners () {
    if (!this.els?.swatch?.exists) return

    super.setupListeners()

    this.isDesktopMode = window.BAO.MediaBreakpoints.isMd

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.onViewportChange = this.onViewportChange.bind(this)
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.VIEWPORT.CHANGE,
      this.onViewportChange,
    )

    if (this.isDesktopMode) {
      this.initDesktopListeners()
    }
  }

  initDesktopListeners () {
    this.els.swatch.elements.forEach((swatch) => {
      this.listeners.add(swatch, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(swatch, 'mouseleave', this.handleMouseLeave)
    })
  }

  removeDesktopListeners () {
    this.els.swatch.elements.forEach((swatch) => {
      this.listeners.remove(swatch, 'mouseenter', this.handleMouseEnter)
      this.listeners.remove(swatch, 'mouseleave', this.handleMouseLeave)
    })
  }

  onViewportChange ({ detail }) {
    const newIsDesktop =
      detail.currentBreakpoint !== 'xxs' && detail.currentBreakpoint !== 'xs'

    if (newIsDesktop && !this.isDesktopMode) {
      this.isDesktopMode = true
      this.initDesktopListeners()
    } else if (!newIsDesktop && this.isDesktopMode) {
      this.isDesktopMode = false
      this.removeDesktopListeners()
    }
  }

  handleMouseEnter (e) {
    this.els.name.element.textContent = e.currentTarget.dataset.name
  }

  handleMouseLeave () {
    this.els.name.element.textContent = this.els.name.element.dataset.default
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.VIEWPORT.CHANGE,
      this.onViewportChange,
    )
  }
}

if (!customElements.get('product-colours')) {
  customElements.define('product-colours', ProductColours)
}
